import { z } from "zod";

const trackstarConnectionsSchema = z.object({
  connectionId: z.string(),
  type: z.string(),
});
export const trackstarConnections = z.object({
  returnConnections: trackstarConnectionsSchema.array(),
  omsConnections: trackstarConnectionsSchema.array(),
});

export type TrackstarConnections = z.infer<typeof trackstarConnections>;
export const getTrackstarConnections = {
  input: z.object({}),
  output: z.object({ connections: trackstarConnections.nullable() }),
};
